export default __webpack_public_path__ + "static/media/p20.d55bb875.jpeg";